export default __webpack_public_path__ + "static/media/rightIMG.b6eebc80.jpg";